import { app } from '../../../../app';
import { Controller } from './recovery-settings.controller';

app.component('recoverySettings', {
    bindings: {
        phoneNumbers: '<',
        recoverySettingsData: '<',
    },
    controller: Controller,
    templateUrl: require('./recovery-settings.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/phone-numbers/recovery-settings/recovery-settings.component.js